'use client';

import { c as _c } from "react/compiler-runtime";
import { TextLink } from '@petsmart-ui/sparky';
import { useState } from 'react';
import { clsx } from '@libs/common-next';
import type { LinkTilesProps } from '../types';
import LinkBlock from './LinkBlock';
import './Tile4Links.scss';
export default function Tile4LinksMobile(t0) {
  const $ = _c(16);
  const {
    tiles
  } = t0;
  const [isMoreClicked, setIsMoreClicked] = useState(false);
  const t1 = isMoreClicked && "tile4-links--mobile--spread";
  let t2;
  if ($[0] !== t1) {
    t2 = clsx("tile4-links--mobile", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isMoreClicked || $[3] !== tiles) {
    let t4;
    if ($[5] !== isMoreClicked) {
      t4 = (linkBlock, index) => <LinkBlock key={linkBlock.sysId} {...linkBlock} {...[2, 3].includes(index) && !isMoreClicked && {
        style: {
          display: "none"
        }
      }} />;
      $[5] = isMoreClicked;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = tiles.map(t4);
    $[2] = isMoreClicked;
    $[3] = tiles;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[7] !== isMoreClicked) {
    t4 = () => setIsMoreClicked(!isMoreClicked);
    $[7] = isMoreClicked;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = isMoreClicked ? "Show Less" : "Show More";
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <TextLink className="tile4-links--mobile__link" onClick={t4}>{t5}</TextLink>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t6) {
    t7 = <div className={t2}>{t3}{t6}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}